/* ActivityTypeRenderer.js */

"use strict";

const _ = require("lodash");

class ActivityTypeColumnRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("activity-type-column");
        this._rootElem.component = this._model;

        this._icon = document.createElement("actionable-icon-gl");
        this._icon.dataset.disabled = "true";
        this._rootElem.appendChild(this._icon);

        this._registerListeners();
        this.render();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _shutdown() {
        const prom = new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._model = undefined;
            this._icon.remove();
            this._icon = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            resolve();
        });
        return prom;
    }

    _registerListeners() {
        this._model.on("ActivityType", (this._onActivityType = this._onActivityType.bind(this)));
        this._model.on("Tooltip", (this._onTooltip = this._onTooltip.bind(this)));
    }

    _unregisterListeners() {
        this._model.removeAllListeners("ActivityType");
        this._model.removeListener("Tooltip", this._onTooltip);
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._setActivityType(this._model.getActivityType());
            this._setTooltip(this._model.getTooltip());
            resolve();
        });
        return prom;
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onActivityType(newVal) {
        this._setActivityType(newVal);
    }

    _onTooltip(newVal) {
        this._setTooltip(newVal);
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    _setActivityType(newVal) {
        if (!_.isUndefined(newVal)) {
            this._icon.remove();
            switch (newVal) {
                case "note":
                    this._icon.dataset.icon = "common.avatar";
                    break;
                case "system":
                    this._icon.dataset.icon = "configdrift.system_note";
                    break;
                default:
                    this._icon.dataset.icon = "common.unknown";
                    break;
            }
            this._rootElem.appendChild(this._icon);
        }
    }

    _setTooltip(newVal) {
        if (!_.isUndefined(newVal)) {
            this._rootElem.title = newVal;
        } else {
            this._rootElem.removeAttribute("title");
        }
    }

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = ActivityTypeColumnRenderer;
